module.exports = __webpack_public_path__ + "static/accounts_aws_2-a6229441eb2babff786b868540307cb7.png";